var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaymentMethodAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "#1F72CD",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6668 8.72388L2.61572 13.4641H5.07115L5.37555 12.7083H6.07134L6.37574 13.4641H9.07847V12.8872L9.3193 13.4641H10.7174L10.9582 12.875V13.4641H16.5791L17.2626 12.7279L17.9026 13.4641L20.7896 13.4701L18.7321 11.1072L20.7896 8.72388H17.9474L17.2821 9.44643L16.6622 8.72388H10.5474L10.0223 9.94736L9.48488 8.72388H7.03459V9.28109L6.76201 8.72388H4.6668ZM13.0605 9.39699H16.2883L17.2756 10.5107L18.2946 9.39699H19.2819L17.7819 11.1065L19.2819 12.7964H18.2499L17.2626 11.6698L16.2384 12.7964H13.0605V9.39699ZM13.8577 10.7222V10.1012V10.1007H15.8717L16.7505 11.0937L15.8328 12.0921H13.8577V11.4142H15.6186V10.7222H13.8577ZM5.14188 9.39699H6.33877L7.69924 12.6113V9.39699H9.01039L10.0612 11.7017L11.0296 9.39699H12.3342V12.7984H11.5404L11.5339 10.1331L10.3766 12.7984H9.66653L8.50274 10.1331V12.7984H6.86969L6.56009 12.0358H4.88745L4.5785 12.7977H3.70352L5.14188 9.39699ZM5.17307 11.3309L5.72413 9.97249L6.27456 11.3309H5.17307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodAmex);
export default __webpack_public_path__ + "static/media/icon_payment_method_amex.b1cb9e81e2f64729262b0ee512d3ff73.svg";
export { ForwardRef as ReactComponent };